// project import
import Navigation from "./navigation";

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = ({open, handleDrawerToggle}) => <Navigation open={open} handleDrawerToggle={handleDrawerToggle}/>;

export default DrawerContent;
